/**
 * --------------------------------------------------------------------
 *
 * 	This component is used to open a small window on the Overfitting Page
 *  that shows the user an example of ML disasters: a woman killed by
 *  an Uber self driving car.
 *
 * -------------------------------------------------------------------
 */

import React from "react";
import Dialog from "@material-ui/core/Dialog";
import Typography from "@material-ui/core/Typography";
import {
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  makeStyles,
} from "@material-ui/core";

interface DialogProps {
  handleClose: () => void;
  open: boolean;
  image: any;
}

const useStyles = makeStyles((theme) => ({
  car: {
    justifyContent: "center",
    textAlign: "center",
  },
  dialogText: {
    textAlign: "justify",
  },
}));

export default function DialogWindow(props: DialogProps) {
  const classes = useStyles();
  return (
    <div>
      <Dialog
        onClose={props.handleClose}
        aria-labelledby="customized-dialog-title"
        open={props.open}
      >
        <DialogTitle id="customized-dialog-title">
          Hazards of Machine Learning - Autonomous Driving
        </DialogTitle>
        <DialogContent dividers>
          <div className={classes.car}>
            <a href="https://www.npr.org/2019/11/07/777438412/feds-say-self-driving-uber-suv-did-not-recognize-jaywalking-pedestrian-in-fatal-?t=1619714797605">
              <img src={props.image} alt="car" />
            </a>
            <br /> <br />
          </div>
          <Typography gutterBottom className={classes.dialogText}>
            Poorly performing machine learning models can have rather drastic
            consequences. Incidents of self-driving cars killing pedestrians
            serve as a notable example. Back in 2018, a 49 year old woman was
            hit and killed by an Uber self-driving car. The woman was walking
            across the street with her bicycle outside the crosswalk. Since the
            machine learning models were not trained on a data set that was
            diverse enough, the car failed to determine whether the woman was a
            pedestrian, vehicle, or bicycle. Clearly, the model was not suitable
            to detect and interpret jaywalking pedestrians. Read more{" "}
            <a href="https://www.npr.org/2019/11/07/777438412/feds-say-self-driving-uber-suv-did-not-recognize-jaywalking-pedestrian-in-fatal-?t=1619714797605">
              {" "}
              here
            </a>
            .
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button autoFocus onClick={props.handleClose} color="primary">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
